import { Fragment } from "react";


export function IconsContainer(props: {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
}) {
    const childrenArray = Array.isArray(props.children)
        ? props.children
        : [props.children];

    return (
        <div className={`flex gap-2 items-center ${props.className}`}>
            {childrenArray.map((child, index) => (
                <Fragment key={index}>{child}</Fragment>
            ))}
        </div>
    );
}
